/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ICON_CHEVRON_RIGHT, SdsIcon } from '@squiz/sds';
import { getCapabilityPath } from 'apps/console-core/src/Utilities/GetCapabilityPath/GetCapabilityPath';
import React, { KeyboardEvent, MouseEvent, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { COMPONENT_SERVICE_STRINGS } from '../../../../../Constants/Strings.constants';
import { ComponentDetailsSetsItemProps } from './ComponentDetailsSetsItem.props';

/**
 * Component details sets list item.
 */
export const ComponentDetailsSetsItem = (props: ComponentDetailsSetsItemProps): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { set, namespace, name } = props;
  const [componentSetPath, setComponentSetPath] = React.useState<string>('');
  const labels = {
    viewSet: t(COMPONENT_SERVICE_STRINGS.viewInSet),
  };

  useEffect(() => {
    if (namespace && name) {
      setComponentSetPath(getCapabilityPath(`/component-sets/${set.webPath}/${namespace}/${name}`));
    } else {
      setComponentSetPath(getCapabilityPath(`/component-sets/${set.webPath}`));
    }
  }, [name, namespace, set.webPath]);

  const navigateToComponentSet = useCallback((): void => {
    navigate({ pathname: componentSetPath });
  }, [componentSetPath, navigate]);

  const goToComponentSetMouseHandler = (event: MouseEvent<HTMLDivElement>): void => {
    navigateToComponentSet();
  };

  const goToComponentSetKeyboardHandler = (event: KeyboardEvent<HTMLDivElement>): void => {
    const navigateKeys = ['Enter', 'Space'];
    if (navigateKeys.includes(event.code)) {
      navigateToComponentSet();
    }
  };

  return (
    <li className="component-details__sets-list-item">
      <span className="component-details__sets-list-title">{set.displayName}</span>
      <div
        className="component-details__sets-list-manage"
        onClick={goToComponentSetMouseHandler}
        onKeyDown={goToComponentSetKeyboardHandler}
        role="link"
        tabIndex={0}
      >
        {labels.viewSet}
        <SdsIcon svg={ICON_CHEVRON_RIGHT} />
      </div>
    </li>
  );
};
